module.exports = __webpack_public_path__ + "img/user-mark.8925f312.png";